import { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import './EditableTableCell.css';

const isValidDraftValue = (draftValue: string) =>
  draftValue !== '' && !isNaN(Number(draftValue));

export const EditableTableCell = ({
  prefix,
  suffix,
  value,
  onChange,
  style,
}: {
  prefix?: string;
  suffix?: string;
  value: string;
  onChange: (_: string) => void;
  style?: React.CSSProperties;
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draftValue, setDraftValue] = useState(value);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    // Find the parent row element (look for a div that contains multiple columns/siblings)
    let parent = containerRef.current.parentElement;
    while (parent) {
      // Check if this element looks like a row (has flex display or multiple direct children)
      const style = window.getComputedStyle(parent);
      if (style.display === 'flex' && parent.children.length > 2) {
        const rowElement = parent;
        rowElement.classList.add('row-with-editable-cell');
        return () => {
          rowElement.classList.remove('row-with-editable-cell');
        };
      }
      parent = parent.parentElement;
    }
  }, []);

  return isEditing ? (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        fontWeight: 'bold',
        verticalAlign: 'middle',
        justifyContent: 'center',
        ...style,
      }}
    >
      <p>{prefix}</p>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <input
          style={{
            maxWidth: '80px',
            fontSize: 16,
            fontWeight: 'bold',
            textAlign: 'left',
            margin: '0 5px',
            padding: '0px 5px',
            borderRadius: 15,
            height: 35,
            backgroundColor: 'white',
            border: '2px solid',
          }}
          autoFocus
          value={draftValue}
          onChange={(e) => setDraftValue(e.target.value)}
          onBlur={() => setTimeout(() => isEditing && setIsEditing(false), 100)}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <button
          style={{
            backgroundColor: '#49D594',
            color: 'white',
            height: 30,
            width: 30,
            marginLeft: '5px',
          }}
          onClick={() => {
            if (isValidDraftValue(draftValue)) {
              onChange(draftValue);
              setIsEditing(false);
            }
          }}
        >
          ✔
        </button>{' '}
      </div>
      {!isValidDraftValue && <span style={{ color: 'red' }}>Invalid</span>}
    </div>
  ) : (
    <div
      ref={containerRef}
      className="editable-cell-container"
      style={{ ...style }}
      onClick={() => setIsEditing(true)}
    >
      <div className="editable-cell-text">
        <span>
          {prefix}
          {value}
          {suffix}
        </span>
        <FontAwesomeIcon icon={faPen} className="editable-cell-pen-icon" />
      </div>
    </div>
  );
};
